import React from 'react';
import PropTypes from 'prop-types';

import { CSSValue, ResponsiveProp, responsivePropType } from '../utils/responsiveProp';
import { StyledLayout } from './Layout.styles';
import { LayoutComponent, LayoutProps } from './types';

export const Layout = ((props: LayoutProps) => <StyledLayout {...props} />) as LayoutComponent;

const align = ['leading', 'center', 'trailing', 'stretch', 'spaceBetween'] as const;

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  wrap: responsivePropType(PropTypes.bool),
  direction: responsivePropType(
    PropTypes.oneOf(['stack', 'inline', 'stackReverse', 'inlineReverse'] as const)
  ),
  gap: responsivePropType(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  align: responsivePropType(PropTypes.oneOf(align)),
  alignItems: responsivePropType(PropTypes.oneOf(align)),
  padding: responsivePropType(
    PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
    ])
  ) as PropTypes.Validator<ResponsiveProp<CSSValue>>,
};

Layout.defaultProps = {
  wrap: false,
  direction: 'inline',
  gap: 0,
};
